import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import LOGOSVG from '../../../assets/icons/logo.svg';
import { Button, Typography } from '../../../designComponents';
import { btnData, routes } from '../data';
import { LaptopContainer } from '../MobileHeader/style';

const LaptopHeader = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleBtnClick = (id: number) => {
    if (id === 0) {
      navigate('/login');
    } else if (id === 1) {
      navigate('/register');
    }
  };
  return (
    <LaptopContainer>
      <div className="main-nav">
        <img
          src={LOGOSVG}
          alt="logo"
          width={35}
          height={35}
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
        <div className="main-routes">
          {routes.map((route, idx) => (
            <Link to={route.url} key={idx} style={{ textDecoration: 'none' }}>
              <Typography
                variant="title"
                style={{
                  color: route.url === pathname ? theme.colors.primary : '',
                }}
                size={14}
              >
                {route.label}
              </Typography>
            </Link>
          ))}
          <div className="btn">
            {btnData.map((data, idx) => (
              <Button
                outline={idx === 0}
                color={idx === 1 ? '#fff' : theme.colors.primary}
                key={idx}
                style={{
                  borderRadius: '30px',
                  height: '33px',
                }}
                size="sm"
                onClick={() => handleBtnClick(idx)}
              >
                {data.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </LaptopContainer>
  );
};

export default LaptopHeader;
